import VueCookie from 'vue-cookie'
import { CURRENT_SERVER, FINANCE_SERVER } from '@/constants/domains'
const axios = require('axios')

export default {
  gmailMailing () {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get('mailing')
  },
  distributionMailing (body) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('mailing/distribution', body)
  },
  emailSend (header, body) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        ...header
      }
    })
    return instCred.post('emailactions/send', body)
  },
  gmailActions ({
    spam = false,
    limit = 20,
    labelIds,
    header,
    nextPageToken,
    q
  }) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        ...header
      }
    })
    const query = [`spam=${spam}`, `limit=${limit}`]
    if (labelIds) query.push(`labelIds[]=${labelIds}`)
    if (nextPageToken) query.push(`nextPageToken=${nextPageToken}`)
    if (q) query.push(`q=${q}`)
    return instCred.get(`emailactions?${query.join('&')}`)
  },
  getThread ({threadId, header}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        ...header
      }
    })
    return instCred.get(`emailactions/thread/${threadId}`)
  },
  moveToTrash (id, body) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        ...body
      }
    })
    return instCred.put(`emailactions/trash/${id}`)
  },
  moveToUnTrash (id, body) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        ...body
      }
    })
    return instCred.put(`emailactions/unTrash/${id}`)
  },
  unReadLetter (id, header, body) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        ...header
      }
    })
    return instCred.put(`emailactions/label/${id}`, body)
  },
  readLetter (id, header, body) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        ...header
      }
    })
    return instCred.delete(`emailactions/label/${id}`, {data: {
      ...body
    }})
  },
  deleteForever (id, body) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        ...body
      }
    })
    return instCred.delete(`emailactions/${id}`)
  },
  getAttachmentById ({header, messageId, attachmentId}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        ...header
      }
    })
    const query = [`messageId=${messageId}`, `attachmentId=${attachmentId}`]
    return instCred.get(`emailactions/attachment?${query.join('&')}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/Gmail/api.js